import cx from 'classnames';
import styles from '../../styles/rent.scss';
import { getPrevDate, getPrevMonthAndYear } from '../../utils/rentUtils';
import { MONTH_TEXT_MAP } from '../../constants';

export const RentReceipts = (props: any) => {
  return (
    <div className="print-receipt-wrap">
      {props.rentPerMonth.map((el, i, array) => {
        let { startDate, endDate } = el;
        const { rent } = el;

        const endDateTimeStamp = endDate.getTime(); // Getting timestamp of end date to compare with current date
        startDate = startDate.toDateString();
        endDate = endDate.toDateString();
        const currentDate = new Date(); // For future receipts putting current date

        const lastEndDate = i === array.length - 1;
        const isReceiptProvisional = endDateTimeStamp > currentDate.getTime(); // Receipt is provisional for future dates
        const isLastMonthSDayIsGreaterThanEday =
          new Date(endDate).getDate() <= new Date(startDate).getDate();

        return (
          <div
            key={String(i)}
            className={cx(
              styles['receipt'],
              styles['box-flex'],
              styles['flex-column']
            )}
          >
            {isReceiptProvisional ? (
              <div className="center">
                <span>Provisional</span>
              </div>
            ) : null}
            <div className={cx(styles['box-flex'], styles['pad8'])}>
              <div className={cx(styles['box-flex'], styles['flex-column'])}>
                <h5 className={cx(styles['no-wrap'])}>
                  <strong>RENT RECEIPT</strong>
                  <span>
                    {lastEndDate && !isLastMonthSDayIsGreaterThanEday
                      ? `${
                          MONTH_TEXT_MAP[
                            getPrevMonthAndYear(endDate, 0).month + 1
                          ]
                        } ${getPrevMonthAndYear(endDate, 0).year}`
                      : `${
                          MONTH_TEXT_MAP[
                            getPrevMonthAndYear(endDate, 1).month + 1
                          ]
                        } ${
                          getPrevMonthAndYear(
                            endDate,
                            getPrevMonthAndYear(endDate, 0).month === 0 ? 1 : 0
                          ).year // Added to fix wrong year issue in december month
                        }`}
                  </span>
                </h5>
                <p style={{ padding: '10px 0px 5px 0px' }}>
                  <a href="/save/rent">Generated on ClearTax</a>
                </p>
              </div>
              <div className={cx(styles['box-flex'], styles['flex-column'])}>
                <p>Receipt No: {i + 1}</p>
                <p>
                  Date:{' '}
                  {isReceiptProvisional
                    ? props.getDateRepr(currentDate.toDateString()).date
                    : props.getDateRepr(endDate).date}
                </p>
              </div>
            </div>
            <p
              style={{ padding: '24px 5px 24px 5px' }}
              className={cx(styles['receipt-body'])}
            >
              Received sum of INR <strong>Rs.{Math.round(rent)}</strong> from{' '}
              <strong>{props.name}</strong> towards the rent of property located
              at <strong>{props.address}</strong> for the period from{' '}
              <strong>{props.getDateRepr(startDate).date}</strong> to{' '}
              {lastEndDate ? (
                <strong>{props.getDateRepr(endDate).date}</strong>
              ) : (
                <strong>
                  {props.getDateRepr(getPrevDate(endDate, 1)).date}
                </strong>
              )}
            </p>
            <p style={{ padding: '10px 5px 10px 5px' }}>
              <strong>{props.owner} </strong>
              <span style={{ padding: '12px', color: '#999' }}>(Landlord)</span>
              {props.pan ? (
                <strong>
                  Pan: <span>{props.pan}</span>
                </strong>
              ) : null}
            </p>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/rent/RentReceipts.tsx